<div class="text-center" *ngIf="isUserWebhookPresent && !isNewRecord">
    <button class="btn btn-sm btn-outline-secondary"
        id="{{idString}}-editbtn-{{params.rowIndex}}" style="vertical-align: baseline; font-size: 12px;"
        (click)="handleActionClickEvent('edit')"><i class="fa-solid fa-pen fa-fw"></i>
    </button>
    <button class="btn btn-sm btn-outline-secondary" id="{{idString}}-deletebtn-{{params.rowIndex}}"
        style="vertical-align: baseline; font-size: 12px; margin-left: 8px;"
        (click)="handleActionClickEvent('delete')"><i class="fas fa-trash-alt fa-fw"></i>
    </button>
</div>